import CustomerService from "services/CustomerService";
import ContractService from "services/ContractService";
import OrderService from "services/OrderService";
import InvoiceService from "services/InvoiceService";
import DocumentService from "services/DocumentService";
import ModeOfTransportationService from "services/ModeOfTransportationService";
import ItemService from "services/ItemService";

export const services = {
  customerService: new CustomerService(),
  contractService: new ContractService(),
  orderService: new OrderService(),
  invoiceService: new InvoiceService(),
  documentService: new DocumentService(),
  modeOfTransportationService: new ModeOfTransportationService(),
  itemService: new ItemService(),
};

export const useCustomerService = (): CustomerService => {
  if (!services?.customerService) {
    throw Error("Customer service not initialized");
  }
  return services.customerService;
};
export const useContractService = (): ContractService => {
  if (!services?.contractService) {
    throw Error("Contract service not initialized");
  }
  return services.contractService;
};
export const useOrderService = (): OrderService => {
  if (!services?.orderService) {
    throw Error("Order service not initialized");
  }
  return services.orderService;
};
export const useInvoiceService = (): InvoiceService => {
  if (!services?.invoiceService) {
    throw Error("Invoice service not initialized");
  }
  return services.invoiceService;
};
export const useDocumentService = (): DocumentService => {
  if (!services?.documentService) {
    throw Error("Document service not initialized");
  }
  return services.documentService;
};
export const useModeOfTransportationService =
  (): ModeOfTransportationService => {
    if (!services?.modeOfTransportationService) {
      throw Error("Mode of Transportation service not initialized");
    }
    return services.modeOfTransportationService;
  };
